<template>
  <div id="warp_sim12">
    <div class="content" style="padding:1rem 0;">
        <div style="position: relative; left: -1.7rem">
          <a-form-model
            ref="ruleForm"
            :model="form"
            labelAlign="right"
            layout="inline"
            hideRequiredMark
          >
            <a-row>
              <a-col :span="12" class="asas">
                <a-form-model-item prop="securitiesAccount" ref="securitiesAccount" label="帳戶號碼">
                  <a-input
                    v-model="form.account_number"
                    auto-complete="new-accounts"
										disabled
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item  label="客戶名稱">
                  <a-input disabled v-model="form.customer_name" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop='customer_identity' label="客戶身份">
                  <a-select v-if="entrustEdit &&  (items.audit_schedule == 0 ||  items.audit_schedule == 3)"  :placeholder="'請選擇客戶身份'" :class="{ border_red: obj.falg1 }"  v-model="form.customer_identity" @focus="obj.falg1=false">
                    <a-select-option v-for='(item , ind) in options1' :value="item.value" :key='ind'>
                      {{item.label}}
                    </a-select-option>
                  </a-select>
                  <a-input v-else disabled v-model="options1[form.customer_identity-1].label" />
								</a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="risk_type" label="風險評級" >
                  <a-select v-if="entrustEdit &&  (items.audit_schedule == 0 ||  items.audit_schedule == 3)" :placeholder="'請選擇風險評級'" v-model="form.risk_type" :class="{ border_red: obj.falg2 }" @focus="obj.falg2=false">
                    <a-select-option v-for='(item , ind) in options2' :value="item.value" :key='ind'>
                      {{item.label}}
                    </a-select-option>
                  </a-select>
                   <a-input v-else disabled v-model="options2[form.risk_type-1].label" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="rating_date" label="評級日期">

                  <a-date-picker v-if="entrustEdit &&  (items.audit_schedule == 0 ||  items.audit_schedule == 3)"  @change='fanhand' format="YYYY-MM-DD" placeholder="請選擇評級日期" v-model="form.rating_date" :class="{ border_red: obj.falg3 }" @focus="obj.falg3=false">
									</a-date-picker >
                   <a-input v-else disabled v-model="form.rating_date" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                 <a-form-model-item prop="account_status" label="帳戶狀態">
                  <a-input disabled v-model="form.account_status"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </div>
			<div style="text-align: right;border-top: 1px solid #e5e5e5;padding: 1rem 0;" v-if="entrustEdit">
				<button
          v-if="items.audit_schedule == 0  || items.audit_schedule == 3"
          style="background-color: rgb(244, 141, 40);"
					class="btn1 btnx"
					v-html="'提 交'"
          @click="subClick()"
				></button>
			</div>
			<div style=" display: flex;  align-items: center; justify-content: right; border-top: 1px solid #e5e5e5;padding: 1rem 0;"  v-if="entrustAudit&&items.account_status!=2">
        <a-textarea v-model='form.remark' placeholder=" " allow-clear  style='width: 56%;margin-left: 1.7rem;'/>
				<button
          style="background-color: #ed4849"
					class="btn1 btnx"
					v-html="'審核拒絕'"
           @click="auditEntrust(2)"
				></button>
				<button
					class="btn1 btnx"
					v-html="'審核通過'"
           @click="auditEntrust(1)"
				></button>
			</div>
  </div>
</template>

<script>
import App from "@/assets/app.js";
export default {
  props: ["items","father"],
  data() {
    return {
      // 編輯
      entrustEdit: this.$store.state.rolesdata.indexOf('entrustEdit') >= 0,
      // 審核
      entrustAudit: this.$store.state.rolesdata.indexOf('entrustAudit') >= 0,
      options:[
        {value:'全部'}, 
        {value:'正常'}, 
        {value:'取消'}
      ],
      options1:[
        {value:1,label: "一般投資者"}, 
        {value:2,label: "專業投資者"},
      ],
      options2:[
        {value:1,label: "保守型"}, 
        {value:2,label: "穩健型"},
        {value:3,label: "均衡型"},
        {value:4,label: "增長型"},
        {value:5,label: "進取型"}
      ],
      form:{
        account_number:'',
        customer_name:'',
        customer_identity:undefined,
        risk_type:undefined,
        rating_date:'',
        account_status:'',
        remark:'',
      },
      obj:{
        falg1:false,
        falg2:false,
        falg3:false,
      }
      
    
    };
  },
  mounted() {
    console.log(this.items);
    console.log(this.items.account_status);
    // this.form.account_number = this.items.account_number
    // this.form.customer_name = this.items.customer_name
    // if (this.items.account_status) {
    //   this.form.account_status = this.options[this.items.account_status].value
    // }
    this.getEntrustInfo()

  },

  methods: {
    fanhand(val) {
      this.form.rating_date = this.form.rating_date? App.oDate.secsTime3(this.form.rating_date._d) : ''
    },

    subClick(){
      if (!this.form.customer_identity) {
        this.obj.falg1 = true
        return
      }
      if (!this.form.risk_type) {
        this.obj.falg2 = true
        return
      }
      if (!this.form.rating_date) {
        this.obj.falg3 = true
        return
      }
      var account_status 
      if (this.form.account_status) {
        if (this.form.account_status == '正常') {
          account_status = 1
        }else{
          account_status = 2
        }
      }
      this.$ajax({
        method: "post",
        url: this.$api.addEntrustAudit,
        data: {
          account_number:this.form.account_number,
          customer_name:this.form.customer_name,
          customer_identity:this.form.customer_identity,
          risk_type:this.form.risk_type,
          rating_date:this.form.rating_date,
          account_status:account_status,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          App.oTool.successT('操作成功');
          this.father.handleCancel()
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    auditEntrust(val){
      if (val == 1) {
        this.form.remark = "審核通過"
      }
      if (!this.form.remark) {
          App.oTool.warningT('請填寫備註信息');
          return
      }
      this.$ajax({
        method: "post",
        url: this.$api.auditEntrust,
        data: {
          account_number:this.form.account_number,
          audit_flag:val,
          remark:this.form.remark,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          App.oTool.successT('操作成功');
          this.father.handleCancel()
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },

    getEntrustInfo(){
      this.$ajax({
        method: "post",
        url: this.$api.getEntrustInfo,
        data: {
          account_number:this.items.account_number,
          audit_schedule:this.items.audit_schedule,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.form = res.data
          this.form.account_status = this.options[this.items.account_status].value
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },

  },
};
</script>
<style >
  @media screen and (min-width:2200px){
    .phoneSty .ant-input-affix-wrapper .ant-input-prefix {
      left: 2px !important;
      top: 33px !important;

    }
  }
  .acco_class{
    background: #f5f5f5;
    color: rgba(0,0,0,.25) !important;
  }
  #warp_sim12 .radio_cla  .ant-form-item-control{
    width: 50% !important;
  }
 
   #warp_sim12 .ant-input[disabled]{
		color: #000;
    background-color: #f5f5f5;
	}
   #warp_sim12 .ant-select-disabled .ant-select-selector{
		color: #000 !important;
    background-color: #f5f5f5 !important;
	}
  .border_red .ant-select-selection{
    border-color: red !important;
  }
  .border_red .ant-input{
    border-color: red !important;
  }
</style>

<style lang="scss" scoped>


.sign_class{
  width: 100%;
  height: 1.75rem;
  border: 1px solid #d9d9d9;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  padding: 0 11px;
  border-radius:4px;
  position: relative;
}
.sign_pop{
  position: absolute;
  width: 100%;
  left: 0;
  top: 2rem;
  z-index: 9;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 0.75rem;
  padding: 5px 12px;
}
.sign_pop_class{
  display: flex
  
}
.sign_pop_margin{
  margin-left: auto;
  font-weight: 600;
}

.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}

.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 100%;
  margin: 0 auto;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 28%;
  }

  .ant-col-12 {
    text-align: center;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 15% !important;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 0.5rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 7rem;
    height: 2.5rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
		margin-right: 1.7rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
</style>
